import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from '../ui/Button';

const SelectionSummary = ({ selections = {}, onEdit, onClear }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const selectionItems = [
    {
      key: 'floorType',
      label: 'Floor Type',
      icon: 'Grid3x3',
      value: selections?.floorType?.name || 'Not selected'
    },
    {
      key: 'baseColor',
      label: 'Base Color',
      icon: 'Palette',
      value: selections?.baseColor?.name || 'Not selected',
      color: selections?.baseColor?.hex
    },
    {
      key: 'flakeColor',
      label: 'Flake Color',
      icon: 'Sparkles',
      value: selections?.flakeColor?.name || 'Not selected',
      color: selections?.flakeColor?.hex
    },
    {
      key: 'room',
      label: 'Room',
      icon: 'Home',
      value: selections?.room?.name || 'Not selected'
    }
  ];

  const hasSelections = Object.values(selections)?.some(val => val !== null && val !== undefined);

  return (
    <div className="selection-summary lg:block hidden">
      <div className="selection-summary-header">
        <h3 className="selection-summary-title">Your Selection</h3>
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="text-text-secondary hover:text-text-primary transition-colors duration-150"
          aria-label={isCollapsed ? 'Expand summary' : 'Collapse summary'}
        >
          <Icon name={isCollapsed ? 'ChevronDown' : 'ChevronUp'} size={20} />
        </button>
      </div>
      {!isCollapsed && (
        <>
          <div className="space-y-1">
            {selectionItems?.map((item) => (
              <div key={item?.key} className="selection-summary-item">
                <Icon name={item?.icon} size={16} className="text-text-secondary mt-0.5" />
                <div className="flex-1 min-w-0">
                  <div className="selection-summary-item-label">{item?.label}</div>
                  <div className="flex items-center gap-2">
                    {item?.color && (
                      <div
                        className="w-4 h-4 rounded border border-border"
                        style={{ backgroundColor: item?.color }}
                      />
                    )}
                    <div className="selection-summary-item-value truncate">{item?.value}</div>
                  </div>
                </div>
                {selections?.[item?.key] && onEdit && (
                  <button
                    onClick={() => onEdit(item?.key)}
                    className="text-primary hover:text-primary/80 transition-colors duration-150"
                    aria-label={`Edit ${item?.label}`}
                  >
                    <Icon name="Edit2" size={14} />
                  </button>
                )}
              </div>
            ))}
          </div>

          {hasSelections && onClear && (
            <div className="mt-4 pt-4 border-t border-border">
              <Button
                variant="outline"
                size="sm"
                fullWidth
                onClick={onClear}
                iconName="X"
                iconPosition="left"
                iconSize={14}
              >
                Clear All
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SelectionSummary;